// extracted by mini-css-extract-plugin
export default {"columns":"Teachers_columns__74xGk"};